import {createDefaultLogger, LogTarget} from '@hconnect/common/logging'

const isDev = process.env.NODE_ENV === 'development' || 'Cypress' in window
const isQA = process.env.REACT_APP_STAGE === 'qa'

const target: LogTarget = isDev || isQA ? 'console' : 'azure'

export const Log = createDefaultLogger('hproduce', target)
